/* iter55u — Extracted from BookDetailModal.jsx.
 *
 * "Better together" bundle list rendered under the buy CTA. Purely
 * presentational; parent owns the checkout side-effect.
 */
import React from 'react';
import { GitBranch } from 'lucide-react';
import { Money } from '@/contexts/CurrencyContext';

export default function BookDetailBundles({ bundles, onBuyBundle }) {
  if (!bundles?.length) return null;
  return (
    <div className="mt-6">
      <div className="mb-2 flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
        <GitBranch className="h-3 w-3" /> Better together
      </div>
      <div className="space-y-2">
        {bundles.map((b) => (
          <button
            key={b.id}
            onClick={() => onBuyBundle(b)}
            data-testid={`buy-bundle-${b.id}`}
            className="relative block w-full overflow-hidden rounded-md border border-border bg-card p-3 text-left transition hover:border-primary/50 hover:shadow-panel-active"
          >
            {/* iter-greyrom followup — bundle refresh ribbon.
                iter-romance25 — Retire once expiry has passed. */}
            {b.new_addition_note && !(b.new_addition_expires_at && new Date(b.new_addition_expires_at) < new Date()) && (
              <div
                data-testid={`bs-detail-bundle-new-ribbon-${b.id}`}
                className="pointer-events-none absolute -right-8 top-2 rotate-45 bg-oxblood px-8 py-0.5 text-[8.5px] font-bold uppercase tracking-[0.16em] text-white shadow"
              >
                {b.new_addition_note}
              </div>
            )}
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                {b.book_covers?.some(Boolean) && (
                  <div className="flex shrink-0 -space-x-3">
                    {b.book_covers.filter(Boolean).slice(0, 3).map((url, i) => (
                      <img
                        key={i}
                        src={url}
                        alt=""
                        className="h-12 w-8 rounded-sm border border-border object-cover shadow-sm"
                        style={{ zIndex: 10 - i }}
                      />
                    ))}
                  </div>
                )}
                <div>
                  <div className="text-[13px] font-semibold">{b.title}</div>
                  <div className="text-[11px] text-muted-foreground">{b.blurb}</div>
                </div>
              </div>
              <div className="text-right">
                {/* iter-53e — Bundle-level overrides honoured for the bundle price. */}
                <div className="text-[13px] font-semibold text-primary">
                  <Money usdCents={b.bundle_price_cents} overrides={b.price_overrides} />
                </div>
                <div className="text-[10px] text-muted-foreground line-through">
                  <Money usdCents={b.regular_price_cents} />
                </div>
                <div className="text-[10px] font-semibold text-success">{b.savings_label}</div>
                <div className="mt-1 text-[10px] font-semibold uppercase tracking-wide text-primary">Buy bundle →</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
